/**
 * @module パンくずリスト共通コンポーネント
 */
export default {
  name: 'BreadCrumbList',
  data() {
    return {
      reloadImage: require('@/assets/images/icon/reload-gray.png'),
      items: [],
    };
  },
  props: {
    reloadFlag: {
      type: Boolean,
      default: true,
      required: false,
    },
    firstText: String,
    firstRouter: String,
    secondText: String,
    secondRouter: String,
    thirdText: String,
    thirdRouter: String,
    fourthText: String,
    fourthRouter: String,
    fifthText: String,
    fifthRouter: String,
    sixthText: String,
    sixthRouter: String,
  },
  /** @type {Methods} */
  methods: {
    /**
     * 画面リロード
     */
    reset: function () {
      // this.$router.go({ path: this.$router.currentRoute.path, force: true });
      window.location.reload();
    },
    /**
     * パンくず項目の設定
     * @returns lists リストデータ
     */
    itemSet: function () {
      var lists = [];
      if (this.secondText) {
        lists.push({
          text: this.firstText,
          disabled: false,
          href: this.firstRouter,
          to: this.firstRouter,
        });
        if (this.thirdText) {
          lists.push({
            text: this.secondText,
            disabled: false,
            href: this.secondRouter,
            to: this.secondRouter,
          });
          if (this.fourthText) {
            lists.push({
              text: this.thirdText,
              disabled: false,
              href: this.thirdRouter,
              to: this.thirdRouter,
            });
            if (this.fifthText) {
              lists.push({
                text: this.fourthText,
                disabled: false,
                href: this.fourthRouter,
                to: this.fourthRouter,
              });
              if (this.sixthText) {
                lists.push(
                  {
                    text: this.fifthText,
                    disabled: false,
                    href: this.fifthRouter,
                    to: this.fifthRouter,
                  },
                  {
                    text: this.sixthText,
                    disabled: true,
                    href: this.sixthRouter,
                    to: this.sixthRouter,
                  }
                );
              } else {
                lists.push({
                  text: this.fifthText,
                  disabled: true,
                  href: this.fifthRouter,
                  to: this.fifthRouter,
                });
              }
            } else {
              lists.push({
                text: this.fourthText,
                disabled: true,
                href: this.fourthRouter,
                to: this.fourthRouter,
              });
            }
          } else {
            lists.push({
              text: this.thirdText,
              disabled: true,
              href: this.thirdRouter,
              to: this.thirdRouter,
            });
          }
        } else {
          lists.push({
            text: this.secondText,
            disabled: true,
            href: this.secondRouter,
            to: this.secondRouter,
          });
        }
      } else {
        lists.push({
          text: this.firstText,
          disabled: true,
          href: this.firstRouter,
          to: this.firstRouter,
        });
      }
      this.items = lists;

      return lists;
    },
  },
  computed: {
    i18nItems() {
      return this.itemSet();
    },
  },
  mounted() {
    this.itemSet();
  },
};
